import React from 'react';

import DropZone from '@ts-core/core/components/DropZone';
import RichTextEditor from '@ts-core/components/RichTextField';

import Typography from '@ts-core/components/Typography';

interface FeedbackFormProps {
  onSelectFile: (file: File) => void;
  file?: File;
  maxFileSize?: number;

  text?: string;
  onTextChange: (text: string) => void;
}

const FeedbackForm = (props: FeedbackFormProps) => {
  const { file, onSelectFile, maxFileSize, text, onTextChange } = props;
  return (
    <>
      <Typography variant="subtitle2">Devolución</Typography>
      <DropZone
        maxSize={maxFileSize}
        onDropFile={onSelectFile}
        file={file}
        message="Arrastra aquí el archivo que deseas subir o hace click para seleccionar un archivo."
      />
      <RichTextEditor onChange={onTextChange} value={text} />
    </>
  );
};

export default FeedbackForm;
